export function passwordLengthError(value) {
  const length = Array.from(value).length;
  if (length < 15) return 'Use at least 15 characters. Try a few unrelated words.';
  if (length > 128) return 'Use no more than 128 characters.';
  return '';
}
